import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Subject} from 'rxjs';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {IconViewModel} from '@features/file-manager/models/file-manager.model';
import {FileStoreCommonService} from '@features/file-manager/services/file-store-common.service';
import {Store} from '@ngrx/store';
import {FileManagerState} from '@features/file-manager/store/reducers/file-manager.reducer';
import {FileSelectionChangedAction} from '@features/file-manager/store/actions/file-manager.actions';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DialogService} from '@shared/services/dialog-service';
import {Subscription} from 'rxjs';
import {FileMetadata} from '@shared/models/file-model';
import {CommandService} from '@core/services/command.service';
import {take, takeUntil} from 'rxjs/operators';
import {ItpDesktopService} from '@core/services/itpdesktopservices/itp-desktop.service';
import {ItpDesktopUtilityService} from '@core/services/itpdesktopservices/itp-desktop-utility.service';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'app-file-store-icon-view',
  templateUrl: './file-store-icon-view.component.html',
  styleUrls: ['./file-store-icon-view.component.scss']
})
export class FileStoreIconViewComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  @Output() parentChanged = new EventEmitter<{ parentId: string, driveId: string }>();
  @Output() selectedItemChanged = new EventEmitter<IconViewModel[]>();
  @ViewChild('uploadToastRef', {static: true}) uploadToastRef: TemplateRef<any>;
  driveId: string;
  parentId: string;
  tags: string;
  isReady = false;
  files: any[] = [];
  queryName: string;
  hideFiles: boolean;
  showHiddenItems = false;
  hideContent = false;
  hideFolders: boolean;
  uploadMessage: string;
  hasDndEnable: boolean;
  isClientDrive: boolean;
  isDialogView: boolean;
  fileExtensionTypes: string[];
  foldersSelectable: boolean;
  selectedItems: IconViewModel[] = [];
  showSelectedItem: boolean;
  selectOnlyCurrentDirectoryFiles: boolean;
  isThumbnailView: boolean;
  public unsubscribe$ = new Subject<void>();
  private uploadSubscription$: Subscription[] = [];
  private overwrite = false;
  private forceCheckIn = false;

  constructor(
    private fileStoreCommonService: FileStoreCommonService,
    private fileManagerStore: Store<FileManagerState>,
    private commandService: CommandService,
    private matSnackBar: MatSnackBar,
    private itpDesktopService: ItpDesktopService,
    private itpDesktopUtilityService: ItpDesktopUtilityService,
    private dialogService: DialogService) {
    this.queryName = 'IconViewQuery';
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.fileManagerStore.dispatch(new FileSelectionChangedAction(null));
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onLoad() {
    this.setData();
    this.isReady = true;
  }

  onIconViewItemClicked($event: IconViewModel) {
    if (this.itpDesktopService.isDesktop() && !this.itpDesktopUtilityService.doOpenFile($event.name)) {
      this.fileStoreCommonService.executeFormAdditionalCommand({
        itemId: $event.itemId,
        driveId: $event.driveId,
        name: $event.name,
        parentIdForDesktop: $event.parentId
      }, $event.type, this.magicLinkModel);
    } else {
      this.fileStoreCommonService.executeFormAdditionalCommand({
        itemId: $event.itemId,
        driveId: $event.driveId,
        name: $event.name
      }, $event.type, this.magicLinkModel);
    }

  }

  onSelectedItemEvent($event: IconViewModel[]) {
    console.log('Selected Items', $event);
    this.fileManagerStore.dispatch(new FileSelectionChangedAction($event));
    this.selectedItemChanged.emit($event);
  }

  onFileDropped($event: any) {
    console.log('onFileDropped');
    this.prepareFilesList($event);
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      item.cancelled = false;
      item.formatedSize = this.fileStoreCommonService.formatBytes(item.size);
      this.files.push(item);
    }
    this.updateToastUploadMessage();
    this.showSnackBar();
    this.uploadFiles(0);
  }

  showSnackBar() {
    if (this.files.length <= 0) {
      return;
    }
    this.matSnackBar.openFromTemplate(this.uploadToastRef, {
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: 'file-upload-toast-container'
    });
  }

  hideSnackbar() {
    const isUploading = this.files.some(file => file.progress < 100 && file.cancelled === false);
    if (isUploading) {
      this.dialogService.showConfirmDialog('Cancel all uploads?', 'Continue Uploads',
        'Cancel Uploads', 'Your uploads are not complete. Would you like to cancel all ongoing uploads?', '')
        .subscribe(res => {
          if (res.action === 'OK') {
            return;
          } else {
            this.resetUploadToast();
          }
        });
    } else {
      this.resetUploadToast();
    }
  }

  cancelUpload(index: number, errorMessage?: string) {
    if (this.uploadSubscription$[index]) {
      this.uploadSubscription$[index].unsubscribe();
    }
    this.files[index].cancelled = true;
    this.files[index].progress = 0;
    if (errorMessage) {
      this.files[index].errorMessage = errorMessage;
    }
    this.updateToastUploadMessage();
    this.uploadFiles(index + 1);
  }

  retryUpload(index: number) {
    this.files[index].cancelled = false;
    this.files[index].progress = 0;
    this.updateToastUploadMessage();
    this.uploadFiles(index, () =>
      this.invalidateSubject.invalidate('OrbitaxDrive'));
  }

  openFile(index: number) {
    if (this.files[index].itemId) {
      const command = new PlatformCommand('OpenFileCommand', 'FileStoreApi');
      command.fieldValues['ItemId'] = this.files[index].itemId;
      command.fieldValues['IsClientDrive'] = true;
      this.fileStoreCommonService.openFile(command);
    }
  }

  onParentChanged($event: { parentId: string, driveId: string }) {
    this.parentChanged.emit($event);
  }

  private setData() {
    this.parentId = this.parentId ?? this.selectedTab.tabData['ParentId'];
    this.driveId = this.driveId ?? this.selectedTab.tabData['DriveId'];
    this.hasDndEnable = this.selectedTab.tabData['HasDndEnable'] ?? false;
    this.isClientDrive = this.selectedTab.tabData['IsClientDrive'];
    if (this.selectedTab.tabData['QueryName']) {
      this.queryName = this.selectedTab.tabData['QueryName'];
    }

    this.isDialogView = this.selectedTab.tabData['IsDialogView'] === true;
    this.fileExtensionTypes = this.selectedTab.tabData['FileExtensionTypes'];
    this.foldersSelectable = this.selectedTab.tabData['FoldersSelectable'] === true;
    this.selectedItems = this.selectedTab.tabData['SelectedItems'] as IconViewModel[];
    this.showSelectedItem = this.selectedTab.tabData['ShowSelectedItem'] ?? true;
    this.selectOnlyCurrentDirectoryFiles = this.selectedTab.tabData['SelectOnlyCurrentDirectoryFiles'] === true;

    this.hideFiles = this.selectedTab.tabData['HideFiles'] === true;
    this.hideFolders = this.selectedTab.tabData['HideFolders'] === true;
    this.tags = this.selectedTab.tabData['Tags'];
    this.showHiddenItems = this.selectedTab.tabData['ShowHiddenItems'];
    this.isThumbnailView = this.selectedTab.tabData['IsThumbnailView'];
  }

  private resetUploadToast() {
    this.files = [];
    this.uploadSubscription$.forEach(sub => sub.unsubscribe());
    this.matSnackBar.dismiss();
  }

  private uploadFiles(index: number, callback?: () => void) {
    if (index === this.files.length) {
      if (this.files.length > 0) {
        this.updateToastUploadMessage();
        this.invalidateSubject.invalidate();
        this.overwrite = this.forceCheckIn = false;
      }
      return;
    } else {
      const file = this.files[index];
      if (file && file.progress < 100 && !file.cancelled) {
        console.log('[Uploading File] of Index: ', index, file);
        this.uploadSubscription$[index] = this.fileStoreCommonService
          .uploadFile(this.getFileData(file))
          .subscribe((res: HttpEvent<Object>) => {
            const event = res['event'] as HttpEvent<Object>;
            switch (event.type) {
              case HttpEventType.Sent:
                console.log('Request has been made!');
                break;
              case HttpEventType.ResponseHeader:
                console.log('Response header has been received!');
                break;
              case HttpEventType.UploadProgress:
                this.files[index].progress = Math.round(
                  (event.loaded / event.total) * 90
                );
                console.log(`Uploaded! ${this.files[index].progress}%`);
                break;
              case HttpEventType.Response:
                console.log('File uploaded successfully!', event.body);
                this.files[index].progress = 100;
                this.files[index].itemId = event.body;
                const command = res['directUploadSuccessCommand'];
                command.fieldValues['FileSize'] = file.size;
                command.fieldValues['HasSnackBarMessage'] = false;
                this.commandService.executePlatformCommand(command)
                  .pipe(
                    take(1),
                    takeUntil(this.unsubscribe$))
                  .subscribe(payload => {
                    if (payload.fieldValues) {
                      this.files[index].itemId = payload.fieldValues['ItemId'];
                      this.invalidateSubject.invalidate('OrbitaxDrive');
                    }
                  });
                if (callback) {
                  callback();
                } else {
                  setTimeout(() => {
                    this.uploadFiles(index + 1);
                  }, 200);
                }
            }
          }, error => {
            console.log('[Upload File] Error Message', error);
            const re = /already exists/;
            if (re.test(error) && !this.overwrite && !this.forceCheckIn) {
              this.showUploadOptionsDialog(error, index);
            }
            if (this.overwrite || this.forceCheckIn) {
              this.uploadFiles(index + 1);
            }
            if (!re.test(error)) {
              this.cancelUpload(index, error);
            }
          });
      } else {
        this.uploadFiles(index + 1);
      }
    }
  }

  private showUploadOptionsDialog(error: string, index: number) {
    const dialogModel = DialogModel.create('Upload Options', 'UploadOptionsDialogComponent', {error});
    dialogModel.okCaption = 'Upload';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state && state.action === 'OK') {
        const {option} = state.data.input;
        switch (option.id) {
          case 'replace-existing-file':
            this.overwrite = true;
            this.uploadFiles(index);
            break;
          case 'keep-both-files':
            this.forceCheckIn = true;
            this.uploadFiles(index);
            break;
          default:
            this.cancelUpload(index, error);
            break;
        }
      }
    });
  }

  private getFileData(file: any): { formData: FormData, fileMetaData: FileMetadata } {
    const fileName = file ? file.name.slice(0, file.name.lastIndexOf('.')) : null;
    const fileExtension = file ? file.name.slice(file.name.lastIndexOf('.'), file.name.length) : null;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName + fileExtension);
    formData.append('parentId', this.parentId);
    formData.append('driveId', this.driveId);
    formData.append('overwrite', this.overwrite ? 'true' : 'false');
    formData.append('forceCheckIn', this.forceCheckIn ? 'true' : 'false');

    const fileMetaData = new FileMetadata();
    fileMetaData.fileName = formData.get('fileName').toString();
    fileMetaData.driveId = this.driveId;
    fileMetaData.parentId = this.parentId;
    fileMetaData.publishEvent = false;
    fileMetaData.overwrite = this.overwrite;
    fileMetaData.forceCheckIn = this.forceCheckIn;
    return {formData, fileMetaData};
  }

  private updateToastUploadMessage() {
    const inProgress = this.files.filter(file => file.progress < 100 && file.cancelled === false).length;
    const cancelled = this.files.filter(file => file.cancelled).length;
    const completed = this.files.filter(file => file.progress >= 100).length;
    if (inProgress) {
      this.uploadMessage = `Uploading ${inProgress} Item`;
    }
    if (cancelled) {
      this.uploadMessage = inProgress > 0 ? `Uploading ${inProgress} Item, ${cancelled} Item Cancelled` : `${cancelled} Item Cancelled`;
    }
    if (completed === this.files.length) {
      this.uploadMessage = 'Upload Completed';
    }
  }
}
